import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityZNSTemplateApi } from 'api';

export const findEntityZNSTemplate = createAsyncThunk(
  'entityZNSTemplate/findEntityZNSTemplate',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityZNSTemplateApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  entityTasks: Array<any>;
  isFirstLoading: boolean;
  reloadFlag: boolean;
}

const initialState: IState = {
  entityTasks: [],
  isFirstLoading: false,
  reloadFlag: false,
};

const entityZNSTemplateSlice = createSlice({
  name: 'entityZNSTemplate',
  initialState,
  reducers: {
    reloadEntityZNSTemplate(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: entityZNSTemplateReducer } = entityZNSTemplateSlice;

export const { reloadEntityZNSTemplate } = actions;

export default entityZNSTemplateReducer;
